import { render, staticRenderFns } from "./User-View-Pdf.vue?vue&type=template&id=476cc4a1&"
import script from "./User-View-Pdf.vue?vue&type=script&lang=js&"
export * from "./User-View-Pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports